import { gxGetDirectDebitAccounts } from "@/app/apiConfig/services/accountsAbstractApiLayer";
import type { DirectDebitAccount } from "@/app/types/accounts";
import { useEffect, useState, type Dispatch, type SetStateAction } from "react";

interface UseDirectDebitAccount {
  page: number;
  setLoading?: Dispatch<SetStateAction<boolean>>;
  search?: string;
}
export const useDirectDebitAccount = ({
  page,
  setLoading,
  search,
}: UseDirectDebitAccount) => {
  const [directDebitAccounts, setDirectDebitAccounts] = useState<
    DirectDebitAccount[]
  >([]);
  const [hasMore, setHasMore] = useState<boolean>(true);

  const getDirectDebitAccounts = async (makeEmpty: boolean) => {
    try {
      setLoading?.(true);

      const payload = {
        pageNo: page,
        pageSize: 10,
        searchText: search ?? "",
      };
      const result = await gxGetDirectDebitAccounts(payload);

      if (result?.data) {
        // Make a shallow copy first
        const directDebitAccountsTemp = makeEmpty
          ? []
          : [...directDebitAccounts];

        result?.data.forEach((item) => {
          const exists = directDebitAccountsTemp.some(
            (acc) => acc.accountId === item.accountId,
          );
          if (!exists) {
            directDebitAccountsTemp.push(item);
          }
        });

        // Update state with the new array
        setDirectDebitAccounts(directDebitAccountsTemp);

        if (result.data.length < 10) {
          setHasMore(false);
        }
      } else {
        setHasMore(false);
      }
    } catch (err) {
      console.log("Error in getDirectDebitAccounts::", err);
      setHasMore(false);
    } finally {
      setLoading?.(false);
    }
  };

  useEffect(() => {
    if (hasMore) {
      getDirectDebitAccounts(false);
    }
  }, [page]);

  useEffect(() => {
    setDirectDebitAccounts([]);
    setHasMore(true);
    getDirectDebitAccounts(true);
  }, [search]);

  return {
    directDebitAccounts,
    hasMore,
  };
};
